import React from 'react';

function Outro() {
  return (
    <div className="section regular center outro">
      <div className="container">
        <div className="summary">
          <h1>Summary</h1>
          <p>
            <strong>Limited Impact of Food Security</strong>
          </p>
          <p>
            To conclude, food insecurity has limited impact on migration issue.
            The correlation between food security and migration intension and
            action are not significant in these three countries.
          </p>
          <br />
          <p>
            <strong>Food Insecurity and Migration</strong>
          </p>
          <p>
            People with better food supply tend to have greater desire to
            migrate. Yet their possibility of making solid plan for migration is
            smaller.
          </p>
          <br />
          <p>
            One explanation to this might be, as people need less to worry about
            basic need for food, they may have more resources and time to think
            of new possibilities such as migration that may further improve
            their living standard. However, these better-off people do not
            necessarily make actual plan for migration in the near future
            compared with the food insecure.
          </p>
          <br />
          <p>
            <strong>Migration Issue's Complexity</strong>
          </p>
          <p>
            Migration issue is a complicated and multi-causal subject that
            require a much wider perspective. Food security shall not be
            considered as the only solution or even bargaining chip to solve the
            immigration issue, but rather a bottom line that every nation and
            individual shall hold and ensure.
          </p>
          <br />
          <p>
            From the survey, it’s astonishing to see that there is still a large
            portion of people suffering food insecurity in the triangle region.
            Ensuring basic human right – the right to food is undoubtedly the
            first priority.
          </p>
        </div>
        <div className="sources">
          <div className="reference">
            <h1>Reference</h1>
            <ul>
              <li>
                Abuelafia, Emmanuel, Giselle Del Carmen, Marta Ruiz-Arranz. “In
                the footprints of migrants: Perspectives and experiences of
                migrants from El Salvador, Guatemala and Honduras in the United
                States.” Inter-American Development Bank: Creative Commons,
                2019.
              </li>
              <li>
                World Food Programme, “Climate crisis and economic shocks leave
                millions food insecure across Central America”, UN News, 23
                February 2021
              </li>
              <li>
                Clemens, Michael. “The Real Root Causes of America’s Border
                Crisis And How Biden Can Address Them.” Foreign Affairs. 7 June
                2021.
              </li>
            </ul>
          </div>
          <div className="data-source">
            <h1>Data Source</h1>
            <ul>
              <li>
                <a href="https://www.fao.org/faostat/en/#data/FS">
                  Prevalence of moderate and severe food insecurity in the total
                  population by nations, 2020
                </a>
              </li>
              <li>
                <a href="https://www.un.org/development/desa/pd/content/international-migrant-stock">
                  International Migrant Stock, Population Division, United
                  Nations, 2020
                </a>
              </li>
              <li>
                Anonymized data from 5000+ Household Interviews conducted by a
                joint initiative between World Food Program and the Migration
                Policy Institute and the International Organization for
                Migration. For privacy and security issue, the original dataset
                would not be shared, 2020.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Outro;
